module.exports = __webpack_public_path__ + "static/media/uzh4.c1d7deea.jpg";